import React from "react";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import servicesData from "../data/servicesData";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
import ConsultationForm from "../sections/ConsultationForm";
export default function Services() {
    const { t } = useTranslation();
    UseScrollAnimation();

    const showData = servicesData.map((el, index) =>
        <div key={index} className="js-scroll fade-top w-100 w-[33%] h-[380px] p-[25px] border-[1px] border-[#eee] flex flex-col justify-between gap-[10px]">
            <div>
                <img src={el.icon} alt="" />
            </div>
            <div className="font-bold text-[22px] border-b-4 border-[#b39359] w-fit">{t(`${el.title}`)}</div>
            <div className="text-[14px]">{t(`${el.details}`)}</div>
            <div className="flex items-center justify-between">
                <Link className="bg-[#B39359] text-white px-[20px] py-[8px] rounded font-bold capitalize" to={"/contact"}>{t("Call us now")}</Link>
                <div>
                    <img className="w-[25px] h-[25px]" src={el.number} alt="" />
                </div>
            </div>
        </div>)
    return (
        <>
            <section className="services-landing">
                <div className="container relative h-full flex flex-col items-center justify-center">
                    <div className="">
                        <div className="btmAni2000 font-bold text-white text-[40px] capitalize">{t("What We Offer")}</div>
                    </div>
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="f-col gap-res-20 container flex flex-wrap justify-center">
                    {showData}
                </div>
            </section>

            <section className="relative py-[40px]">
                <div className="container">
                    <div className="w-100 flex mx-auto w-[75%] flex-col gap-[5px] items-center justify-center text-center">
                        <div className="js-scroll fade-top font-bold text-[25px] capitalize">{t("You can get a free consultation now")}</div>
                        <p className="js-scroll fade-btm">
                            {t("Fill in the fields and you will be contacted as soon as possible.")}
                        </p>
                    </div>
                </div>
            </section>

            <ConsultationForm/>
        </>
    );
}